import React, { useState } from 'react';
import * as S from './TravellerDetail.styles';
import { ITRAVELLER_BLOCK_INFO, ITRAVELLER_BLOCK_PAX } from './../../../../containers/Review/Validation'

type TravellerDetailProps = {
  headerId?: string;
  travellerNumber?: string | number;
  seatNumber?: string;
  seatType?: string;
  passengerType?: string;
  isError?: boolean;
  genderType?: string
  travellerInfo: ITRAVELLER_BLOCK_INFO;
  onChange?: Function;
  onGenderChange?: Function;
  pax_prefill: ITRAVELLER_BLOCK_PAX[]
  onPaxSelect: Function;
};

const TravellerDetailCard = ({
  headerId,
  travellerNumber,
  seatNumber,
  seatType,
  passengerType,
  isError = true,
  genderType,
  travellerInfo,
  onChange,
  onGenderChange, pax_prefill, onPaxSelect
}: TravellerDetailProps) => {
  const [isCollapsed, collpase] = useState(getInitState(travellerInfo));
  let { name, age, gender, nameErr, ageErr, genderErr, ageMaxLength } = travellerInfo;

  const male_icon = "https://gos3.ibcdn.com/male_gender-1655186004.png"
  const female_icon = "https://gos3.ibcdn.com/female_gender-1655186015.png";
  const add_traveller_icon = "https://gos3.ibcdn.com/add_traveller-1655216972.png";

  return (
    <S.TravellerForm id={`travellerForm${travellerNumber}`}>
      <S.FormHeaderInput type="checkbox" id={headerId}></S.FormHeaderInput>
      <S.FormHeaderLabel htmlFor={headerId} onClick={() => {
        collpase(!isCollapsed)
      }}>
        <S.FormLabelTxt>
          <img src={add_traveller_icon} className="travellerIcon" />
          <S.FlexOne>
            <S.TravellerInfo>
              <S.FlexOne>
                <S.TravellerNumber> {`Traveller ${travellerNumber}`}</S.TravellerNumber>
                <S.PassengerType>{name ? `${name} ${age ? `(${age} years)` : ''}` : passengerType}</S.PassengerType>
              </S.FlexOne>
              <S.SeatNumber>{`Seat ${seatNumber}`}</S.SeatNumber>
            </S.TravellerInfo>
          </S.FlexOne>
        </S.FormLabelTxt>
      </S.FormHeaderLabel>
      {!isCollapsed ?
        <S.FormContent>
          <S.FormWrap>
            <S.FormInnerContent>
              <S.FullName>
                <label>Full Name</label>
                <>
                  <input type="text" placeholder="Enter Full Name" className={`${nameErr ? 'error' : ''}`} value={name} data-travellernum={travellerNumber} data-val="name" data-seatnum={seatNumber} onChange={onChange} />
                  {nameErr ? <S.Error>{nameErr}</S.Error> : null}
                </>
              </S.FullName>
              <S.Age>
                <label>Age</label>
                <>
                  <input type="text" placeholder="Age" maxLength={ageMaxLength} className={`${ageErr ? 'error' : ''}`} value={age} data-travellernum={travellerNumber} data-val="age" data-seatnum={seatNumber} onChange={onChange} />
                  {ageErr ? <S.Error>{ageErr}</S.Error> : null}
                </>
              </S.Age>

              <S.GenderWrap>
                <label>Gender</label>
                <ul className={`genderTabs ${genderErr ? 'error' : ''}`}>
                  {(!genderType || genderType === 'maleOnly') ?
                    <li onClick={(e) => { onGenderChange("Male", travellerNumber, 'gender', seatNumber) }}
                      className={`genderTabsList ${gender === "Male" ? "selected" : ""}`}>
                      <img src={male_icon} className="genderIcon" />
                      <span>Male</span>
                    </li> : null}

                  {(!genderType || genderType === 'femaleOnly') ?
                    <li onClick={(e) => { onGenderChange("Female", travellerNumber, 'gender', seatNumber) }}
                      className={`genderTabsList ${gender === "Female" ? "selected" : ""}`}>
                      <img src={female_icon} className="genderIcon" />
                      <span>Female</span>
                    </li> : null}

                </ul>
                {genderErr ? <S.Error>{genderErr}</S.Error> : null}
              </S.GenderWrap>
            </S.FormInnerContent>
            <S.NameListWrap>
              {pax_prefill && pax_prefill.length ? getPrefillView({ pax_prefill, travellerNumber, genderType, onPaxSelect }) : null}
            </S.NameListWrap>
          </S.FormWrap>
        </S.FormContent> : null}
    </S.TravellerForm>
  );
}

export default TravellerDetailCard;

const getPrefillView = (params) => {
  const MAX_PAX_COUNT = 5;
  const { pax_prefill: data, travellerNumber, onPaxSelect, genderType } = params;
  let view = [];
  for (const i in data) {
    const { gender, f_name, id, age } = data[i];
    if (+i <= MAX_PAX_COUNT && ((genderType === "femaleOnly" && gender === 'Female') || (genderType === "maleOnly" && gender === 'Male') || !genderType)) {
      view.push(<S.NameList key={f_name + gender + age + travellerNumber} onClick={() => {
        onPaxSelect({ gender, f_name, age, id, travellerNumber });
      }}>{f_name}</S.NameList>
      )
    }

  }
  return view;
}

const getInitState = (travellerInfo) => {
  let val = false;
  const { name, age, gender, nameErr, ageErr, genderErr } = travellerInfo;
  if (name && age && gender && !nameErr && !ageErr && !genderErr) {
    val = true;
  }
  return val;
}
